// this file might be a symlink
// magic values will be replaced during docker container runtime

module.exports = {
    NEXT_SHOP_EXTERNAL_URL: 'https://shop-1.demo.connectico.pl',
    NEXT_SHOP_EXTERNAL_DOMAIN: 'shop-1.demo.connectico.pl',
    BACKEND_INTERNAL_URL: 'http://backend-internal:8080',
    BACKEND_EXTERNAL_URL: 'https://panel.shop-1.demo.connectico.pl/api',
    TINYMCE_API_KEY: 'connectico'
}
